module.exports = __webpack_public_path__ + "img/device_fan_e.ef6fcf91.png";